module.exports = __webpack_public_path__ + "static/media/footer-logo.0bae3366.svg";